import { Component, OnInit, NgZone } from '@angular/core';
import { LocalStorageService } from 'src/app/Services/auth-service/local-storage.service';
import { Router, ActivatedRoute } from '@angular/router'
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { NavbarService } from './navbar.service';
import { AppService } from 'src/app/app.service';
import { ENDPOINTS, ORG_DETAILS } from 'src/app/app.config';
import { config as configuration } from 'src/configs/config';
import { CheckoutLocalStorageService as CheckoutLocalStorageServiceNew } from 'src/app/Lazy-loaded-Modules/Checkout-new/checkout-local-storage.service';
import { CartNewService } from 'src/app/Lazy-loaded-Modules/Cart-module/cart-new/cart-new.service';
import { CheckoutApiService } from 'src/app/Lazy-loaded-Modules/Checkout-new/checkout-api.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent implements OnInit {
  searchForm: UntypedFormGroup;
  preList = [];
  emptyResult: boolean = false;
  userLoggedIn: boolean = false;
  productOrList: boolean;
  productId: any;
  searchTerm: any;
  allCategories: any;
  resultMessage: any;
  nesmaProducts:any = [];
  is_pincode_validated:boolean=false;
  pincode:any;
  pincodeinput:any;

  logoImage:any = "";
  
  configs = configuration;

  constructor(config: NgbDropdownConfig,
    // private authService: AuthTokenService,
    private localService: LocalStorageService,
    private router: Router,
    private route: ActivatedRoute,
    private ngZone: NgZone,
    public appService: AppService,
    private formBuilder: UntypedFormBuilder,
    private navbarService: NavbarService,
    private checkoutLocalStorageService1: CheckoutLocalStorageServiceNew,
    private cartNewService: CartNewService,
    private checkoutApiService: CheckoutApiService,
    private localStorageService: LocalStorageService,
    ) {
    config.placement = 'bottom-right'
  }
  previouspincode;
  ngOnInit(): void {
    this.getCheckoutSettings();
    this.getLogo();
    this.searchForm = new UntypedFormGroup({
      search_term: this.formBuilder.control('')
    })
    if (this.localService.get("is_pincode_validated") != 'undefined' && this.localService.get("is_pincode_validated")=='true') {
      //The front-end should change when this is called.
     this.is_pincode_validated=true;
     this.pincode=this.localService.get("pincode");
     this.previouspincode=this.localService.get("pincode");
    }
    if (this.localService.get("UserName") != 'undefined' && this.localService.get("UserName")) {
      //The front-end should change when this is called.
      this.appService.userLoggedIn = true;
      this.appService.userName = this.localService.get("UserName");
    }
    else {
      this.appService.userLoggedIn = false;
      this.appService.userName = "New User";
    }
    // TO CLEAR THE SEARCH TERM FROM OTHER EVENTS
    this.navbarService.currentData.subscribe(
      currentData => {
        if (currentData === 'clearSearchTerm') {
          this.closePrelist();
        }
      }
    )

    if(this.cartNewService.getCartItems() !== null){
      this.nesmaProducts = this.cartNewService.getCartItems();
    }

    this.cartNewService.currentData.subscribe(
      currentData => {
        let curData:any = currentData;
        if(curData.type === "cartData"){
          this.nesmaProducts = curData.value;
        }
      }
    )
 
  }
  redirectPage(page){
    if(page === "cart"){
      this.router.navigateByUrl('/cart-new', {skipLocationChange:false})
    }
    else{
      this.router.navigateByUrl('/checkout-new', {skipLocationChange:false})
    }
  }
  pincoderanges;
  opendialog()
  {
    document.getElementById('pincode-model').click();
    
    
    
    
  }
  validatepincode()
  {
    if(this.pincodeinput==undefined)
    {
      document.getElementById('error').style.display='block';
      document.getElementById('verified').style.display='none';
      return false;
    }
    if(this.pincodeinput==this.pincode)
    {
      document.getElementById('error').style.display='none';
      document.getElementById('verified').style.display='block';
      return false;
    }
    var breakme=false;
    this.pincoderanges.forEach(element => {
      if(breakme==false)
      {
        if((Number(this.pincodeinput)>Number(element.key)&&Number(this.pincodeinput)<Number(element.value))||(Number(this.pincodeinput)==Number(element.value))||(Number(this.pincodeinput)==Number(element.key)))
        {
          this.localStorageService.set('is_pincode_validated','true');
          this.localStorageService.set('pincode',this.pincodeinput);
          this.is_pincode_validated=true;
          this.pincode=this.pincodeinput;
          breakme=true;
        }
        else{
          
          this.is_pincode_validated=false;
        }
      }
      
   
     
    });
   
    if(!this.is_pincode_validated)
    {
      this.localStorageService.remove('is_pincode_validated');
      this.localStorageService.remove('pincode');
      document.getElementById('error').style.display='block';
      document.getElementById('verified').style.display='none';
      if(this.previouspincode!=undefined)
      {
        this.localStorageService.set('is_pincode_validated','true');
      this.localStorageService.set('pincode',this.previouspincode);
      this.pincode=this.previouspincode;
      this.is_pincode_validated=true;
      }
    }
    else{
      window.location.reload();
  
    }
  
  
  }
getCheckoutSettings(){
  return new Promise((resolve, reject) => {
    this.checkoutApiService.checkoutAPICall(ENDPOINTS.CHECKOUT_SETTINGS).then(
      respData => {
        let res:any = respData;
        this.pincoderanges=res.data[0].attributes;
        this.localService.set("pincode_ranges",JSON.stringify(this.pincoderanges));
        resolve(res.data[0])
      }
    )
  })
}
// closedialog()
// {
//   this.pincode=this.previouspincode!=undefined?this.previouspincode:this.pincode;
// }
  getPreList(evt) {
    if(evt.keyCode === 13){
      this.savePreList1()
      return
    }
    let searchData = this.searchForm.value.search_term;
    if (searchData.length >= 2) {
      let reqData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": null,
        "extras": {
          "find": {
            "search": searchData
          }
        }
      }
      this.appService.postApiCall(reqData, ENDPOINTS.GET_PRELIST).subscribe(
        resp => {
          this.preList = resp.result.data;
          if (this.preList.length == 0) {
            this.emptyResult = true;
          }
          else {
            this.emptyResult = false;
          }
        },
        err => {
          if (err.error.error.message) {
            console.log(err.error.error.message)
          }
          else {
            console.log('Something bad happened; Please try again!')
          }
        })
    }
    else {
      this.preList = [];
    }
  }
searchname;
searchtype;
  savePreList(val) {
    if (val.type == 'Product Name') {
      this.getCategory(val)
    }
    else {
      this.sendProductDetails(val);
    }
  }

  savePreList1() {
    if(this.searchForm.controls['search_term'].value==""){
      return
    }
    if(this.preList.length==0){
      if(this.configs.title === 'Nesma'){
        this.router.navigate([`/product-listing`], { queryParams: { terms: [this.searchname,this.searchtype], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
      }
      else if(this.configs.title === 'Haven'|| this.configs.title === 'Dosapark' || this.configs.title === 'Tams')
      {
        this.router.navigate([`/product`], { queryParams: { terms: ["", ""], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
   
      }
      else{
        this.router.navigate([`/productListing`], { queryParams: { terms: ["",""], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
      }
      return;
    }
    var searchVal1 = this.searchForm.controls['search_term'].value;
    if (searchVal1) {
    //   this.sendProductDetails(this.preList[0]);
    // }
    if (this.preList[0].type == 'Product Name') {
      this.getCategory(this.preList[0])
    }
    else {
      this.sendProductDetails(this.preList[0]);
    }
  }
  }
  sendProductDetails(searchTerm) {
    let searchRequestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "extras": {
        "find": {
          "search": searchTerm.name
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 1,
          "pagesize": 35
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "id",
          "sortorder": 1
        }
      }
    }

    // MAKE AN API CALL
    this.appService.postApiCall(searchRequestData, ENDPOINTS.GET_SEARCH_RRESULTS).subscribe(
      resp => {
        let respData = resp.result.data;
        this.preList = [];
        this.searchForm.controls['search_term'].setValue(searchTerm.name);
        this.emptyResult = false;
        this.searchname=searchTerm.name;
        this.searchtype=searchTerm.type;
        if(this.configs.title === 'Nesma'){
          this.router.navigate([`/product-listing`], { queryParams: { terms: [searchTerm.name, searchTerm.type], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
        }
        else if(this.configs.title === 'Haven'|| this.configs.title === 'Dosapark' || this.configs.title === 'Tams')
        {
          this.router.navigate([`/product`], { queryParams: { terms: [searchTerm.name, searchTerm.type], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
     
        }else
        {
          this.router.navigate([`/productListing`], { queryParams: { terms: [searchTerm.name, searchTerm.type], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
        }
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })
  }
  getCategory(searchTerm) {
    let req_search_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "extras": {
        "find": {
          "search": searchTerm.name
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 1, "pagesize": 20
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "name",
          "sortorder": 1
        }
      }
    }


    this.appService.postApiCall(req_search_data, ENDPOINTS.GET_SEARCH_RESULT).subscribe(
      resp => {
        let respData = resp.result.data[0];
        this.preList = [];
        this.searchForm.controls['search_term'].setValue(searchTerm.name);
        this.emptyResult = false;
        this.searchname=searchTerm.name;
        this.searchtype=searchTerm.type;
        if(this.configs.title === 'Nesma'){
          this.router.navigate([`/product-listing`], { queryParams: { terms: [searchTerm.name, searchTerm.type], category: [respData.parentcategories[0].name], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
        }
        else if(this.configs.title === 'Haven'|| this.configs.title === 'Dosapark' || this.configs.title === 'Tams')
        {
          this.router.navigate([`/product`], { queryParams: { terms: [searchTerm.name, searchTerm.type], category: [respData.parentcategories[0].name], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
       
        }
        else{
          this.router.navigate([`/productListing`], { queryParams: { terms: [searchTerm.name, searchTerm.type], category: [respData.parentcategories[0].name], type: 'searchresults' }, relativeTo: this.route, skipLocationChange: false });
        }
        
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else {
          console.log('Something bad happened; Please try again!')
        }
      })
  }
  setClass(navLocation: string) {
    let listOfNavs = document.getElementsByClassName('nav-item');
    for (let i = 0; i < listOfNavs.length; i++) {
      listOfNavs[i].classList.remove('active');
    }
    document.getElementById(navLocation).classList.add("active");

  }
  closePrelist() {
    this.searchForm.controls['search_term'].setValue('');
    this.preList = [];
  }
  logIn() {
    this.router.navigate([`/login-new`], { queryParams: { url: this.router.url }, relativeTo: this.route, skipLocationChange: false });
  }
  logOut() {
    this.appService.userLoggedIn = false;
    this.appService.userName = "";
    this.appService.loggedin_user = false;
    this.userLoggedIn = this.appService.loggedin_user;
    var couponSaved = this.localService.get('couponCodeSchift')
    console.log("Coupon Code Saved",couponSaved)
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "coupon_code":couponSaved,
        }
      }
    }
    this.appService.postApiCall(requestData, ENDPOINTS.REMOVE_COUPON).subscribe( 
      resp => {
        if(resp.success === 1){
          this.localService.remove('couponCodeSchift');
        }
      }
    )
    this.localService.remove('accessToken');
    this.localService.remove('refreshToken');
    this.localService.remove('expireTime');
    this.localService.remove('UserName');
    this.localService.remove('UserId');
    this.localService.remove('customerGroup');
    this.localService.remove('domainName');
    this.localService.remove('rexpireTime');
    this.localService.remove('AiemaUserName');
    this.localService.remove('couponCode');
    this.localService.remove('company_name');
    this.localService.remove('gst_number');
    this.localService.remove('company_address');
    this.localService.remove('AppliedCoupon');
    this.router.navigate(["/"]);
    this.checkoutLocalStorageService1.clearDataonLogout();
    this.checkoutLocalStorageService1.removeOrderId();
  }

  getLogo(){
    let data = {
      "domain_name":ORG_DETAILS.DOMAIN_NAME,
      "user_id":ORG_DETAILS.USER_ID,
      "extras":{
      "find": {}
      }
  }
  this.appService.postApiCall(data, ENDPOINTS.STOREGALLERY).subscribe(
    resp => {
      let respData = resp.result.data[0];
      this.logoImage = respData.logo.logo_image_source
    },
    err => {
      if (err.error.error.message) {
        console.log(err.error.error.message)
      }
      else {
        console.log('Something bad happened; Please try again!')
      }
    })
  }

}
